// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2025 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.

import { addToEndOfChain } from "@insite/client-framework/HandlerCreator";
import {
    chain as AddAccountChain,
    ExecuteOnSuccessCallback,
} from "@insite/client-framework/Store/Data/Accounts/Handlers/AddAccount";
import { getCurrentPage } from "@insite/client-framework/Store/Data/Pages/PageSelectors";
import { xGoogleAnalyticsState } from "@tps/App/GoogleAnalyticsConnector/Store/Reducers";
import { getDataLayer } from "@tps/App/GoogleAnalyticsConnector/Utilities/DataLayer";

const _GaSendAddAccountTracking: typeof ExecuteOnSuccessCallback = props => {
    const state = props.getState() as xGoogleAnalyticsState;
    if (state.xGoogleAnalytics.addAccountEvent) {
        if (props.apiResult.successful) {
            const dataLayer = getDataLayer();
            const currentPage = getCurrentPage(state).type;
            if (!dataLayer) {
                return;
            }
            const param = props.parameter as any;
            const googleAnalyticsData = {
                event: state.xGoogleAnalytics.addAccountEventName,
                name:
                    param?.firstName && param?.lastName
                        ? `${param.firstName} ${param.lastName}`
                        : param?.contactName || "",
                company_name: param?.companyName || "",
                city: param?.city || "",
                state: param?.state || "",
                user: param?.email || "",
                customer_id: (props.apiResult as any)?.result?.customer?.id || "",
                page_path: currentPage,
            };
            dataLayer.push(googleAnalyticsData);
        }
    }
};

addToEndOfChain(AddAccountChain, _GaSendAddAccountTracking);
